<template>
  <div>
    <b-form-file
      multiple
      :file-name-formatter="formatNames"
      type="file"
      data-file="general"
      accept=".pdf,.zip,.png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
      class="form-control"
      :placeholder="input.placeholder"
      :required="!input.optional"
      :disabled="input.disabled"
      :name="input.name"
      @change="(e) => handleChange(e)"
      :id="inputId"
    ></b-form-file>
    <div class="upload-file">
      <div class="upload-file-body">
        <div class="left">
          <div class="upload-file-name">
            {{
              thisValue
                ? thisValue.length > 30
                  ? thisValue.substring(0, 28) + "..."
                  : thisValue
                : "Select file to upload"
            }}
          </div>
        </div>
        <div class="right">
          <button
            class="btn btn-outline-primary btn-sm btn-with-icon-right btn-upload"
            @click.prevent="handleClick"
            v-if="input.current_file_url"
          >
            Ubah
            <i class="material-symbols-outlined">file_upload</i>
          </button>

          <button
            class="btn btn-outline-primary btn-sm btn-with-icon-right btn-upload"
            @click.prevent="handleClick"
            v-else
          >
            Upload
            <i class="material-symbols-outlined">file_upload</i>
          </button>
        </div>
      </div>
      <a
        class="upload-file-footer px-3 text-primary"
        v-if="input.current_file_url"
        :href="input.current_file_url"
        download
      >
        {{ input.current_file_url }}
      </a>
      <div class="upload-file-footer" style="display:none">
        <div class="item item-sm upload-size">
          <i class="material-symbols-outlined">casino</i>
          <span><span class="file-size"></span> in size</span>
        </div>
        <div class="item item-sm upload-modified-date">
          <i class="material-symbols-outlined">date_range</i>
          <span>Last modified <span class="file-date"></span></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "UploadMultiFile",
  components: {},
  props: {
    input: Object,
    value: String,
  },
  data: function() {
    return {
      thisValue: this.value,
      inputId: this.input.name + Math.random(10),
    };
  },
  methods: {
    handleChange(e) {
      ////console.log(e);
      ////console.log(e.target.files[0].path);
      let self = this;
      if (e.target.files && e.target.files[0]) {
        var reader = new FileReader();

        reader.onload = function(e) {
          self.thisValue = e.target.result;
        };

        reader.readAsDataURL(e.target.files[0]);
      }
      this.$emit("handleChange", e);
    },
    handleClick() {
      document.getElementById(this.inputId).click();
    },
  },
};
</script>
